import { useImperativeHandle } from 'react';
export default function useCalendarRef(calendarRef, {
  navigate
}) {
  useImperativeHandle(calendarRef, () => ({
    navigate
  }), [navigate]);
}